import { time } from '@/time';
import type { Recipe } from '@/types';

const recipe: Recipe = {
  title: 'Chick-Fil-A Sauce',
  source: 'https://littlesunnykitchen.com/chick-fil-a-sauce-copycat/',
  totalTime: time(0, 35),
  servings: 6,
  tags: { type: 'sauce' },
  ingredients: [
    { name: 'mayonnaise', quantity: '1/2', unit: 'cup' },
    { name: 'bbq sauce', quantity: '1/4', unit: 'cup' },
    { name: 'yellow mustard', quantity: '2', unit: 'tbsp' },
    { name: 'honey', quantity: '2', unit: 'tbsp' },
    { name: 'lemon juice', quantity: '1', unit: 'tbsp' },
    { name: 'salt', quantity: '1/4', unit: 'tsp' },
  ],
  directions: [
    {
      title: 'Combine & chill',
      bullets: [
        "In bowl, whisk {mayonnaise}, {bbq sauce}, {yellow mustard}, {honey}, {lemon juice} & {salt} until homogenous",
        "Refrigerate 30 min before serving to let flavors meld",
      ],
    },
  ],
};

export default recipe;
